import { Check, CheckCheck, AlertCircle, Lock, FlaskConical, Bot, FileBadge, Smartphone } from "lucide-react";
import { bubbleTime } from "@/lib/format";
import { MediaContent } from "@/components/inbox/MediaContent";

const DeliveryIcon = ({ m }) => {
  if (m.delivery === "failed") return <AlertCircle size={13} className="text-red-500" title={m.error} />;
  if (m.delivery === "simulated") return <FlaskConical size={12} className="text-slate-400" title="Simulato (API non configurata)" />;
  if (m.delivery === "read") return <CheckCheck size={14} className="text-sky-500" />;
  if (m.delivery === "delivered") return <CheckCheck size={14} className="text-slate-400" />;
  return <Check size={14} className="text-slate-400" />;
};

export const MessageBubble = ({ m }) => {
  if (m.direction === "note") {
    return (
      <div className="flex justify-center fade-up" data-testid={`internal-note-${m.id}`}>
        <div className="max-w-[90%] md:max-w-[75%] bg-[#FEF9C3] border border-[#FDE047] text-[#713F12] rounded-lg px-4 py-2.5 shadow-sm">
          <div className="flex items-center gap-1.5 text-[10px] uppercase tracking-wider font-bold mb-1"><Lock size={11} /> Nota interna · {m.agent_name}</div>
          <p className="text-sm whitespace-pre-wrap">{m.text}</p>
          <div className="text-[10px] text-right opacity-70 mt-1">{bubbleTime(m.created_at)} · visibile solo al team</div>
        </div>
      </div>
    );
  }
  const out = m.direction === "out";
  const autoText = m.media && ["Foto", "Nota vocale"].includes(m.text) || (m.media?.kind === "document" && m.text === m.media.filename);
  return (
    <div className={`flex ${out ? "justify-end" : "justify-start"} fade-up`} data-testid={`message-${m.direction}-${m.id}`}>
      <div className="max-w-[85%] md:max-w-[65%]">
        <div className={`relative px-3.5 py-2 rounded-xl shadow-sm text-sm ${out ? "bg-[#DCFCE7] border border-[#86EFAC] text-[#064E3B] rounded-tr-sm" : "bg-white border border-slate-200 text-slate-900 rounded-tl-sm"}`}>
          {m.template && <div data-testid="message-template-badge" className="flex items-center gap-1 text-[10px] uppercase tracking-wider font-bold text-[#15803D] mb-1"><FileBadge size={11} /> Modello · {m.template.name}</div>}
          {m.media && <MediaContent m={m} />}
          <p className={`whitespace-pre-wrap leading-relaxed pr-12 ${autoText ? "min-h-3" : ""}`}>{autoText ? "" : m.text}</p>
          <span className="absolute bottom-1.5 right-2.5 flex items-center gap-1 text-[10px] text-slate-500">
            {bubbleTime(m.created_at)} {out && <DeliveryIcon m={m} />}
          </span>
        </div>
        {out && (
          <div data-testid="message-agent-name" className="text-[11px] text-slate-500 mt-1 text-right flex items-center justify-end gap-1">
            {m.agent_id ? null : m.agent_name?.startsWith("Telefono") ? <Smartphone size={11} /> : <Bot size={11} />}
            {m.agent_name}
            {m.delivery === "failed" && <span className="text-red-500"> · invio fallito</span>}
          </div>
        )}
      </div>
    </div>
  );
};
